import Button from "../../design/Button";
import GModal from "../../design/components/GModal";
import classes from "./UnblockContactModal.module.css";

const UnblockContactModal = ({
  visible,
  closeModalHandler,
  saveHandler,
  name,
}) => {
  return (
    <GModal
      heading="Unblock contact"
      visible={visible}
      closeModal={() => {
        closeModalHandler();
      }}
      bodyWrapperStyle={{ paddingRight: 0 }}
      bottomButtons={[
        <Button
          hierarchy="white"
          variant="outlined"
          buttonText="Cancel"
          onClick={() => {
            closeModalHandler();
          }}
        />,
        <Button
          hierarchy="white"
          variant="outlined"
          buttonText="Unblock"
          onClick={saveHandler}
          buttonStyle={{ color: "#E22D20" }}
        />,
      ]}
      body={
        <p className={classes.body}>
          Are you sure you want to unblock <span>{name}?</span>
        </p>
      }
    />
  );
};

export default UnblockContactModal;
